var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-icon"},[_c('img',{staticClass:"icon",attrs:{"src":require("../assets/image/icon/icon_contact.png")},on:{"click":function($event){return _vm.showContact()}}}),_c('img',{staticClass:"icon-m",attrs:{"src":require("../assets/image/icon/icon_contact_m.png")},on:{"click":function($event){return _vm.goContact()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }